let defaultUser = {
    name: '',
    email: '',
    phoneNumber: '',
    phoneNumbers: [{phoneNumber: ''}],
    callsapp_line_id: '',
    password: '',
    roleName: '',
    seniorAgent: null,
    subAgents: null,
    archive: null,
};

export default defaultUser;
